import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/venta_empleados';
import VentaEmpleado from './VentaEmpleadoList';


const ms2p = (state) => {
  return {
    ...state.venta_empleado_rrhh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(VentaEmpleado);